import { configureStore } from '@reduxjs/toolkit';
import { utenteCorrenteReducer } from './utenteCorrenteSlice';
import { siteMapsReducer } from './siteMapsSlice';
import { menuConfigReducer } from './menuConfigSlice';
import { elencoQuestionariReducer } from './elencoQuestionariSlice';
import { questCorrenteReducer } from './questCorrenteSlice';

export const store = configureStore({
  reducer: {
    utenteCorrente: utenteCorrenteReducer,
    menuConfig: menuConfigReducer,
    siteMaps: siteMapsReducer,
    elencoQuestionari: elencoQuestionariReducer,
    questCorrente: questCorrenteReducer,

  }
});

/*
SLICE SOPPRESSO:
import { datiGeneraliReducer } from './datiGeneraliSlice'
import { rilevanzaAmbitiReducer } from './rilevanzaAmbitiSlice';
import { stakeholdersReducer } from './stakeholdersSlice';

    datiGenerali: datiGeneraliReducer,
    rilevanzaAmbiti: rilevanzaAmbitiReducer,
    stakeholders: stakeholdersReducer

*/
